import React from 'react';
import './OauthAuthenticationSpidButton.scss';
import spidLogo from "../Assets/spid_new_icon.svg";
import Configuration from "../../../config";
import {useTranslation} from "react-i18next";
import {isLocalhost} from "../../../helpers/helpers";

const OauthAuthenticationSpidButton = () => {
  const {t} = useTranslation();
  const oAuthRedirectUri = isLocalhost
    ? `https://localhost:3000/${Configuration.get('REACT_APP_OAUTH_REDIRECT_URI')}`
    : `${Configuration.get('REACT_APP_GCAP_PUBLIC_HOST')}/${Configuration.get('REACT_APP_OAUTH_REDIRECT_URI')}`;
  const URL = `https://${Configuration.get('REACT_APP_OAUTH_URL')}/oauth2/authorize?client_id=${Configuration.get('REACT_APP_OAUTH_CLIENT_ID')}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${oAuthRedirectUri}&identity_provider=${Configuration.get('REACT_APP_OAUTH_IDENTITY_PROVIDER')}`;
  return (
    <div className="OauthAuthenticationSpidButton w-100" data-testid="OauthAuthenticationSpidButton">
      <div className="spidLogoContainer"><img src={spidLogo} className="spidLogo" alt="spid-logo"/></div>
      <div className={"spid-text-container"}>
        <p className={'spid-title headline-fs5'}>
          {t('authentication_login_spid.text')}
        </p>
        <p className={'spid-info-text paragraph-small-fs9'}>
          {t('login_spid_first_access_disclaimer')}
        </p>
      </div>
      <a href={URL} className="gcap-cta redirect">{t('authentication_login_spid.button')}<span className="sr-only">{t('authentication_login_spid.sr.only')}</span>
        <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
      </a>
    </div>
  )
};

OauthAuthenticationSpidButton.propTypes = {};

export default OauthAuthenticationSpidButton;
